<div class="logout-dialog new-design-font">
  <p class="logout-dialog__title" translate>Sair</p>
  <p class="logout-dialog__text" translate>Tem certeza que deseja sair de sua conta?</p>
  <div class="logout-dialog__actions">
    <button class="logout-dialog__btn-primary" (click)="confirm()" translate>Sair da conta</button>
    <button class="logout-dialog__btn-secondary" (click)="cancel()" translate>Retornar ao cardápio</button>
  </div>
</div>
